import { render, staticRenderFns } from "./QuantEmbarques.vue?vue&type=template&id=224717d6"
import script from "./QuantEmbarques.vue?vue&type=script&lang=js"
export * from "./QuantEmbarques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports